import React, { useContext } from "react"

import { DragSourceDataContext } from "shared/context/drag-and-drop/DragSourceDataContext"
import { DropHandler } from "shared/types/DragAndDrop"
import { Floor } from "shared/types/Floor"
import { ProductPositionTypename, RoomTypename } from "shared/types/Project"
import { isDragSource } from "shared/types/drag-and-drop/DragSource"

import z from "zod"

import { FloorDropzone } from "./FloorDropzone"
import { NoProductsHint } from "./NoProductsHint"

export interface EmptyStateHintProps {
  floor: Floor | null | undefined
  activeTabID: string | null
  onDrop: DropHandler
}

export const EmptyStateHint = React.memo(
  ({ activeTabID, floor, onDrop }: EmptyStateHintProps) => {
    const { dragSource } = useContext(DragSourceDataContext)

    if (
      dragSource &&
      isDragSource(dragSource, {
        dataSchema: z.object({
          id: z.string(),
          __typename: z
            .literal(RoomTypename)
            .or(z.literal(ProductPositionTypename))
        })
      }) &&
      floor
    ) {
      return <FloorDropzone floor={floor} onDrop={onDrop} />
    }

    return <NoProductsHint activeTabID={activeTabID} />
  }
)
